export default __webpack_public_path__ + "static/media/illustration-element-02.2.9c67834a.svg";